import { Component, EventEmitter, ElementRef, Input, Output, forwardRef, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { bbGenerateShortId } from '../../../shared/utils/bbGenerateShortId.util';

export interface BbCheckboxListOption {
	label: string;
	value: string;
	icon: string;
	iconText?: string;
	checked?: boolean;
}
@Component({
	selector: 'bb-checkbox-list',
	templateUrl: './bb-checkbox-list.component.html',
	styleUrls: ['./bb-checkbox-list.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbCheckboxListComponent),
		multi: true
	}]

})

export class BbCheckboxListComponent implements ControlValueAccessor, OnInit, OnChanges {
	@Input() options: BbCheckboxListOption[];
	@Input() disabledOptions: string[];
	@Input() actionOnly = false;
	@Input() showMoreLimit = 0;
	@Input() numColumns = 1;
	@Input() theme: 'light-v2' | 'default' = 'default';
	@Output() selected = new EventEmitter<BbCheckboxListOption>();

	selectedOption: BbCheckboxListOption;
	el: HTMLElement;
	propagateChange: any;
	id = bbGenerateShortId();
	valueOnlyModel = false;
	modelValue: any = [];
	checkedModels: any = {};
	showMore = false;
	moreCount = 0;
	colsPaddingRight = '0';

	constructor(private _eref: ElementRef) {
		this.el = this._eref.nativeElement;
	}

	ngOnInit() {
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.options && !changes.options.firstChange) {
			this.updateChecked();
		}
	}

	onShowMoreClick() {
		this.showMore = !this.showMore;
		// hack to fix chrome column display bug
		this.colsPaddingRight = '1px';
		setTimeout(() => {
			this.colsPaddingRight = '0';
		}, 1);
	}

	checkChanged(option: BbCheckboxListOption, checked: boolean, index: number) {
		// unique values:
		this.modelValue = Array.from(new Set(this.modelValue));
		if (checked) {
			this.modelValue.push(option.value);
			if (index && this.showMoreLimit && index >= this.showMoreLimit) {
				this.moreCount++;
			}
		} else {
			const i = this.modelValue.indexOf(option.value);
			if (i > -1) {
				this.modelValue.splice(i, 1);
				if (index && this.showMoreLimit && index >= this.showMoreLimit) {
					this.moreCount--;
				}
			}
		}

		if (this.propagateChange) {
			this.propagateChange(this.modelValue);
		}
	}

	updateChecked() {
		this.moreCount = 0;
		this.options.forEach((option, i) => {
			this.checkedModels[option.value] = this.modelValue.indexOf(option.value) !== -1;
			if (this.showMoreLimit && i >= this.showMoreLimit && this.checkedModels[option.value]) {
				this.moreCount++;
			}
		});
	}

	writeValue(values: string[]) {
		this.modelValue = values || [];
		this.updateChecked();
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}
}
